import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../hicrea-sso.constants';

@Component({
  selector: 'app-hicrea-sso-change-password-sent',
  templateUrl: './hicrea-sso-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './hicrea-sso-change-password-sent.component.css',
  ],
})
export class HicreaSsoChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
